import axios from 'axios';
import router from '@/router'

const state = () => ({
  myAxios: axios.create({
    baseURL: `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_HOSTNAME}:${process.env.VUE_APP_PORT}`,
    headers: {
      "Content-Type": "application/json",
      common: {
        "Authorization": 'Bearer ' + localStorage.getItem('token') || null
      }
    },
  }),
  user: {},
})
const getters = {
  getUser(){
    return JSON.parse(localStorage.getItem('user'))
  },
  getToken(){
    return localStorage.getItem('token')
  },
  getAxios(state){
    return state.myAxios
  },
}
const mutations = {
}
const actions = {

  //  AXIOS INTERCEPTORS SETUP
  setUpInterceptors({ state, dispatch }) {
    // Request interceptor
    state.myAxios.interceptors.request.use(
      function(config) {
        let token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }else{
          if (router.currentRoute.name !== 'Login') {
            dispatch('logout');
          }
        }
        return config;
      },
      function(err) {
        return Promise.reject(err);
      }
    );
    
    // Response interceptor
    state.myAxios.interceptors.response.use(
      (response) => {
        // If the response status is between 200 and 299, it's a successful response, so return it as is.
        return response;
      },
      (error) => {
        if (error.response) {
          if (error.response.status === 413) {
            // Handle Payload Too Large (413) error
          } else if (error.response.status === 401) {
            if (router.currentRoute.name !== 'Login') {
              dispatch('logout');
            }
          } else if (error.response.status === 400) {
            console.warn("HA HABIDO UN ERROR EN AXIOS: ", error.response.data.msg ? error.response.data.msg : error.response);
          }
        }

        return Promise.reject(error);
      }
    );
  },



  ////  LOGIN & LOGOUT  ////
  async login({ state }, userInfo) {
    try {
      const res = await state.myAxios.post('auth/login/', userInfo)

      await this.dispatch('api/setToken', res.data.token)
      await this.dispatch('api/setUser', JSON.stringify(res.data.user))
      this.dispatch('cargaInicial')
    }
    catch (error) {
      return error;
    }
  },
  logout({ state }) {
    state.user = {}
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    console.log("logged out");
    router.push({path:'\login'})

  },
  setUser({state}, user){
    state.user = user
    localStorage.setItem('user', user)
  },
  setToken({state},token){
    localStorage.setItem('token', token)
  },

  //// TRABAJADORES ////
  getTrabajadores({state}){
    return state.myAxios.get('trabajadores/')
  },
  deleteTrabajador({state}, id){
    return state.myAxios.put(`trabajadores/${id}`,{})
  },
  createTrabajador({state}, payload){
    return state.myAxios.post(`trabajadores/`,payload)
  },

  ////  PERMISOS  ////
  getTiposPermisos({state}){
    return state.myAxios.get(`permisos/tipos/`)
  },
  createPermiso({state}, payload){
    return state.myAxios.post(`permisos/`, payload)
  },
  getPermisos({state}){
    return state.myAxios.get(`permisos/`)
  },
  getPermisosHoras({state}, payload){
    return state.myAxios.get(`permisos/fecha/`,{params: payload})
  },
  deletePermiso({state}, id){
    return state.myAxios.put(`permisos/${id}`, {})
  },

  ////  FESTIVOS  /////
  getFestivos({state}){
    return state.myAxios.get(`festivos/`)
  },
  createVacaciones({state}, payload){
    return state.myAxios.post(`festivos/`, payload)
  },
  deleteFestivo({state}, id){
    return state.myAxios.put(`festivos/${id}`, {})
  },

  ////  TARJETAS  ////
  deleteAsignacion({state}, payload){
    return state.myAxios.put(`tarjetas/asignacion/`, payload)
  },
  createAsignacion({state}, payload){
    return state.myAxios.post(`tarjetas/asignacion/`,payload)
  },
  createTarjeta({state}, codigo_tarjeta){
    return state.myAxios.post(`tarjetas/`,{codigo_tarjeta: codigo_tarjeta})
  },

  ////  FICHAJES  ////
  getFichajes({state}, payload){
    return state.myAxios.get(`fichajes/`,{params: payload})
  },
  createFichaje({state}, payload){
    return state.myAxios.post(`fichajes/`, payload)
  },
  modificarFichaje({state}, payload){
    return state.myAxios.put(`fichajes/${payload.id}`, payload)
  },
  eliminarFichaje({state}, payload){
    return state.myAxios.put(`fichajes/${payload.id}`, {})
  },
  getHorasTrabajadas({state},payload){
    return state.myAxios.get('fichajes/horas/', {params: payload})
  },
  getHorasTrabajadasEnFestivo({state},payload){
    return state.myAxios.get('fichajes/horas_festivo/', {params: payload})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}